import { useState, useEffect } from "react";
import Cookies from 'js-cookie';
import Navbar from './NavBar';
import axios from "axios";
import { IoEyeSharp } from "react-icons/io5";
import { useNavigate } from 'react-router-dom';
import Nodata from '../../assets/No data.png';
import { toast, ToastContainer } from "react-toastify";
import { TailSpin } from 'react-loader-spinner';
import { MdClear } from "react-icons/md";

const SuperAdminDashboard = () => {
    const token = Cookies.get('jwt_token')
    const [userLoading, setUserLoading] = useState(true);
    const [users, setUsers] = useState([]);
    const [searchCompany,setSearchCompany]=useState('')
    const navigate = useNavigate();

    const getUsers = async () => {
        try {
            setUserLoading(true);
            const response = await axios.get(
                "https://bankdata.inclineanalytics.com/api/all-users",
                {
                headers: {
                  Authorization: `Bearer ${token}`
                }, params: {
                    searchCompany: searchCompany,
                  },});
          if(response.data.success){
            setUsers(response.data.data);
          }
        } catch (error) {
            console.error("Error fetching User list", error);
            toast.error("Error fetching User list, Try again!");
        } finally {
            setUserLoading(false);
        }
    };

    useEffect(() => { 
        getUsers();
        // eslint-disable-next-line
    }, [searchCompany]);

    const updateSearchCompany=(event)=>{
        setSearchCompany(event.target.value)
    }

    return (
        <div className='bg-[#001f3f] max-h-[100vh] h-screen overflow-y-auto'>
            <Navbar />
            <ToastContainer />
            <div className="ml-10 mr-10 mt-3 mb-1 flex justify-between items-center">
            <h1 className="text-2xl font-semibold text-[#ff6f61]">Users Details:</h1>
            <div className="bg-[#ffffff] p-1 flex justify-between w-[280px]  border rounded-lg border-[#ff6f61]">
                <input type="text" className="border-0 ml-2 w-[230px] focus:outline-none" onChange={updateSearchCompany} value={searchCompany} placeholder="Enter search company"/>
                {searchCompany !== "" && <button type="button" onClick={()=>{
                    setSearchCompany('')
                }} className="font-semibold flex flex-col justify-center ml-3 hover:text-[#ff6f61] "><MdClear/></button>
            }
            </div>
            </div>
            <div className="m-10 mt-2 mb-0 bg-[#ffffff] h-[75vh] rounded-lg overflow-auto scrollbar-thin scrollbar-thumb-gray-800 scrollbar-track-gray-300">
                {userLoading ? (
                    <div className="flex flex-col justify-center items-center h-full">
                        <TailSpin
                            visible={true}
                            height="80"
                            width="80"
                            color="#ff6f61"
                            ariaLabel="tail-spin-loading"
                            radius="1"
                            wrapperStyle={{}}
                            wrapperClass=""
                        />
                    </div>
                ) : (
                    <>  
                        {users.length === 0 ? (
                            <div className="flex flex-col h-full justify-center items-center">
                                <img src={Nodata} alt="no-data" className="h-[350px]" />
                                <h1 className="text-2xl text-gray-800">No Users data found</h1>
                            </div>
                        ) : (
                            <div className="min-w-full flex justify-center pb-4">                               
                                <div className="w-11/12 pt-2">
                                    <ol>
                                        {users.map((user,index)=>(
                                            <li key={user.id} className=" w-full text-sm border border-[#ff6f61] p-2 rounded-lg mb-1">
                                                <div className="flex justify-between p-2 pt-0 pb-0">
                                                    <div className="w-1/3 flex items-center">
                                                    <p className=" px-2 font-bold text-gray-800">{index + 1}.</p>
                                                    <p className="text-left px-2 text-gray-900"><span className="font-bold mr-2 text-gray-800">Company Name:</span>{user.companyName}</p>                                                              
                                                    </div>
                                                <p className="w-1/3 flex items-center text-left px-2 text-gray-900"><span className="font-bold mr-2 text-gray-800">Email:</span>{user.email}</p>
                                                <div className="w-1/3 flex justify-end items-center">
                                                <p className="px-2 w-1/2 text-gray-900 text-left"><span className="font-bold mr-2 text-gray-800">User Id:</span>{user.id}</p>
                                                <div className="w-1/2  flex justify-end relative group">
                                                <button
                                                    disabled={!user.otpVerified}
                                                    onClick={() => navigate(`/super-admin/user-institutions/${user.id}`)}
                                                    className={`text-[#ff6f61] text-sm p-2  flex justify-center align-items space-x-1.5 ${user.otpVerified === false ? "text-gray-500 border-gray-500 hover:cursor-not-allowed" : "hover:shadow-custom-orange hover:border-[2px]"} border border-[#ff6f61] rounded-lg`}
                                                    >
                                                    <p>Accounts</p>
                                                    <p className="p-1"> <IoEyeSharp /></p>
                                                </button>
                                                {!user.otpVerified &&(
                                                    <div className="absolute right-1/2 transform -translate-x-4 translate-y-6 p-1 bg-gray-900 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity h-8 w-32">
                                                        User Not Verified
                                                    </div>)}
                                                </div>
                                                
                                                </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ol>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default SuperAdminDashboard;
